import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { autobind } from '../../packages/core/lib';
import {
    TransactionDetail,
    HeaderCompound,
    Grid
} from '../../packages/components';
import {
    showModal,
    MODAL_CALL_CENTER,
    AAF_MODAL_SUCCESS_SUSCRIPTION
} from '../../actions/modal';
import { TransactionDetailType } from '../../packages/components/lib/TransactionDetail';
import Spinner from '../../components/Spinner';
import Assets from '../../requests/apa/Asset';
import Translator from '../../requests/apa/Translator';
import { getwWorkflowstart, parsePBI, parseWorkFlowStart } from './utils'
import { apiPaywayConfirm, onPaymetSuccess, showError, redirectPlayerOneClic, handleTypeModal} from '../utils/Utils';
import store from '../../store';
import Device from '../../devices/device';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import {GETWAY_AMCO, GETWAY_CLAROPAGO, VCARD_CONTRATA, VCARD_COMPONENT} from '../utils/constants';
import { setMetricsEvent } from '../../actions/metrics';
import { COMPONENT_PLAN_SELECTOR, METODO_DE_PAGO, LABER_AGREGAR_MEDIO_DE_PAGO, LABER_CANCELAR_MEDIO_DE_PAGO, EVENT_ACTION_METODO_DE_PAGO } from '../../packages/components/lib/utils/constants';
import './_styles.scss';
import Utils, {setInitialFocus} from 'src/utils/Utils';
import {getTransactionalPrice, getTransactionalTax, getTransactionalBonus} from '../utils/Utils';
import {TRANSACTION_COMPONENT_TICKET, TRANSACTION_COMPONENT_CHECKOUT} from '../utils/constants';
import { Resilence } from 'src/AAF/Resilence/main';
import {GA4} from 'src/utils/trackers/GA4';
import { CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION, DOES_NOT_APPLY } from 'src/utils/trackers/GA4Constants';
const { isPTVUSer } = Resilence;

export interface IDetailPBI {
    isSubscription: boolean,
    isLive: boolean,
    bannerpromo: string,
    currency: string,
    gateway: string,
    key: string,
    linkworkflowstart: string,
    offerid: string,
    groupId?: string,
    islive?: boolean,
    extraDisclaimer?: string,
    oneofferdesc: string,
    oneofferdesckey: string,
    oneoffertype: string,
    paymentmethod: any,
    price: string,
    producttype: string,
    purchasechecked: string,
    purchaseid: string,
    waspurchased: string,
    family: string,
    bonus: string,
    buy: string,
    includes: string,
    frequency: number,
    style: string,
    periodicity: string,
    banner: string,
    hideTextStep?: boolean,
    backButtonAlign?: 'right' | 'left'
}
export interface IcardsData {
    pan: string;
}

export interface IWorkflowItem {
    gateway: string,
    gatewayText: string,
    buyLink: string,
    hubCorpEnabled: boolean,
    product_id: string,
    accessCode: boolean,
    msgAccessCode: string,
    producttype: string,
    buyToken: string,
    paymentMethodData: {
        account: string,
        cardsData: IcardsData[]
    },
    listBuyLinks: any
}

export interface IWorkflowContentInfo {
    contentImageLarge: string,
    contentImageMedium: string,
    contentImageSmall: string,
    contentTitle: string,
    contentOriginalTitle: string,
}

export interface IWorkflowstart {
    hasSavedPayway: boolean,
    hasUserSusc: string,
    list: IWorkflowItem[],
    newWorkflow: string,
    selectedPaymentMethod: string,
    contentInfo?: IWorkflowContentInfo
}

export interface ITransactionDetailState {
    isLoading: boolean,
    worflowstart: IWorkflowstart,
    itemData: any,
}

class TransactionDetailContainer extends Component<RouteComponentProps, ITransactionDetailState>{
    private pbi: IDetailPBI;
    private itemData: any;
    private from: string = '';
    private transactionType: TransactionDetailType;
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    private newMethod: string = '';
    public region: string = DeviceStorage.getItem('region');


    constructor(props: RouteComponentProps) {
        super(props);
        const { location: { state = {}} = {} } = props || {};
        const {itemData = {}} = state;
        this.itemData = itemData;
        this.pbi = parsePBI(state);
        this.newMethod = state.newMethod
        this.from = state.from;
        this.transactionType = this.getTransactionType();
        this.setInitialState();
        this.addEventListener();
    }

    @autobind
    private getTransactionType(): TransactionDetailType {
        const { oneoffertype = '', producttype } = this.pbi;

        if (oneoffertype.toLowerCase().includes('buy')) {
            if (producttype.toLowerCase().includes('season')) {
                return TransactionDetailType.BUY_SEASON;
            } else if (producttype.toLowerCase().includes('episode')) {
                return TransactionDetailType.BUY_EPISODE;
            } else {
                return TransactionDetailType.BUY_MOVIE;
            }
        } else if (oneoffertype.toLowerCase().includes('rent')) {
            return TransactionDetailType.RENT_MOVIE;
        }
        else if (oneoffertype.toLowerCase().includes('subscrition')) {
            return TransactionDetailType.SUSCRIPTION;
        }
        else {
            throw new Error('[AAF Payment] Tipo de transaccion no asociado');
        }
    }

    private setInitialState(): void {
        this.state = {
            isLoading: true,
            worflowstart: {
                hasSavedPayway: false,
                hasUserSusc: '',
                newWorkflow: '',
                list: [],
                selectedPaymentMethod: ''
            },
        };
    };

    private addEventListener(): void {

    }

    private getWorkflow(gateway: string): IWorkflowItem | undefined {
        const { worflowstart: { list } } = this.state;

        if (list && list.length > 0) {
            return list.find(i => i.gateway === gateway);
        }

        if(list && list?.listBuyLinks) {
            return list?.listBuyLinks.find((i: any) => i.gateway === gateway);
        }

        return undefined;
    }

    /**
     * Handlers
     */

    @autobind
    private showModalSusc(groupId: number, provider: string, pbi: object, cb: any): void {
        const props = {
            groupId,
            provider,
            pbi,
            backCallback: cb
        }
        const modal = {
            modalType: MODAL_CALL_CENTER,
            modalProps: props
        };
        store.dispatch(showModal(modal));
    }

    @autobind
    private handleBack(): void {

        const { history } = this.props;
        history.goBack();
    }

    @autobind
    private async handleAcceptSavedPayway(): Promise<void> {
        const { worflowstart } = this.state;
        let { worflowstart: { selectedPaymentMethod } } = this.state
        const { history } = this.props;
        const selectedPaymentMethodOrAmco = this.hasAmcoPayment() ? GETWAY_AMCO : selectedPaymentMethod;
        let selectedWorkFlow = this.getWorkflow(selectedPaymentMethodOrAmco);
        const { isSubscription, producttype } = this.pbi;
        let cb = isSubscription ? (resp: object) => this.redirectAddon(resp) : (resp: object) => this.redirectVCard(resp);
        Utils.sendMetric(this.props, VCARD_CONTRATA, producttype.toLowerCase(), VCARD_COMPONENT);
        if (this.newMethod) {
            selectedWorkFlow = this.getWorkflow(this.newMethod);
            selectedPaymentMethod = this.newMethod;
        }
        if (selectedPaymentMethodOrAmco === GETWAY_CLAROPAGO) {
            history.push(`/payment-${selectedPaymentMethod}`, { pbi: this.pbi, worflowstart, method: selectedPaymentMethod, type: this.transactionType, changeMethod: false });
        } else {
            this.setState({ isLoading: true });
            this.sendGA4Metric(this.transactionType  === TransactionDetailType.SUSCRIPTION ? 'F1':' F2', selectedPaymentMethod);
            apiPaywayConfirm({ pbi: this.pbi, wfs: selectedWorkFlow, formParams: {} })
                .then((resp) => {
                    this.sendGA4Metric('F3', undefined, '4');
                    onPaymetSuccess(resp, this.pbi, selectedWorkFlow, selectedPaymentMethodOrAmco, cb, true);
                })
                .catch(err => {
                    showError(err);
                    this.setState({ isLoading: false });
                });
        }
    }

    @autobind
    private sendGA4Metric(ga4Id:string, selectedPaymentMethod?: string, transaction_id?: string) {
        const gA4 = new GA4();
        const {price, offerid} = this.pbi || {}
        const {item_name, item_id, item_brand, item_category, item_category2, item_category3, item_category4} = this.itemData;
        if (ga4Id === 'F1'){
            gA4.sendPaymentMethodAddedEvent(selectedPaymentMethod || '',item_brand,item_id, price, item_brand, DOES_NOT_APPLY,DOES_NOT_APPLY,item_category3,DOES_NOT_APPLY,1);
        } else if (ga4Id === 'F2') {
            gA4.sendPaymentMethodAddedEvent(selectedPaymentMethod || '',item_name,item_id, price, item_brand, item_category,item_category2,item_category3,item_category4,1);
        } else if (ga4Id === 'F3') {
            if (this.transactionType === TransactionDetailType.SUSCRIPTION) {
                gA4.sendBuyEvent(price, offerid,DOES_NOT_APPLY,item_brand,item_id,price,item_brand,DOES_NOT_APPLY, DOES_NOT_APPLY, CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION, DOES_NOT_APPLY)
            } else {
                gA4.sendBuyEvent(price, offerid,DOES_NOT_APPLY,item_brand,item_id,price,item_brand,DOES_NOT_APPLY, DOES_NOT_APPLY, CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION, DOES_NOT_APPLY)
            }
        }
    }


    @autobind
    private handleAddPayway(): void {
        Utils.sendMetric(this.props, EVENT_ACTION_METODO_DE_PAGO,LABER_AGREGAR_MEDIO_DE_PAGO, METODO_DE_PAGO);
        const { worflowstart, worflowstart: { hasSavedPayway } } = this.state;
        const { history, location } = this.props;
        const changeMethod = hasSavedPayway ? true : false;
        const metricsHistory = this.props.location.state.metricsHistory;
        history.push('/payment-method', { pbi: this.pbi, worflowstart, type: this.transactionType, from: this.from, changeMethod, location, metricsHistory  });
    }


    @autobind
    private handleCancelPayway(): void {
        const { history } = this.props;
        Utils.sendMetric(this.props, METODO_DE_PAGO, LABER_CANCELAR_MEDIO_DE_PAGO, COMPONENT_PLAN_SELECTOR)
        history.goBack();
    }
    /**
     * React Lifecycle Methods
     */

    componentDidMount() {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
        const { user } = store.getState() || {};

        if (user.isLoggedIn) {
            this.getData();
            this.addEventListener();
        }
        else {
            this.sendAnonymousUserToRegister()
        }
    }

    componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW') {
            this.handleBack();
        }
    }

    @autobind
    private sendAnonymousUserToRegister() {

        const { history, location: { state: pbi = {} } = {} } = this.props;
        history.push(`/register`, { ...pbi, isRedirectFromCheckout: true });
    }

    @autobind
    private redirectAddon(resp: any): void {
        this.setState({ isLoading: false });
        const { groupId = '', oneoffertype = '', islive = false } = this.pbi;
        const { worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                const { response: { payway_token = '' } = {} } = resp || {};
                this.handlePlay(groupId, payway_token, islive);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    @autobind
    private handleHomeAddOn(resp: any) {
        const { history, nodes } = this.props;
        const { response: { node_id = '' } = {} } = resp || {};
        let nodeString: string = '';
        const filterNodes = nodes.filter((value: any) => value.code === 'playandgo');
        const resultChilds = filterNodes.map((res: any) => {
            const childsValue = res.childs;
            return childsValue;
        });

        for (let index = 0; index < resultChilds.length; index++) {
            const element = resultChilds[index];

            element.map((resId: any) => {
                if (resId.id === node_id) {
                    return nodeString = resId.code;
                }
            });
        }

        // Este flujo solo es desde el plan selector
        history.replace(`/node/${nodeString ? nodeString : 'homeuser'}`);
    }

    @autobind
    private handlePlay(groupId: string, payway_token: string, islive: boolean) {
        const { history } = this.props;
        const nav = Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
        if (islive) {
            redirectPlayerOneClic(groupId, islive, payway_token, null, () => {
                if(nav && nav.home) {
                    history.replace(`/node/${nav.home}`);
                  }             });
        } else if (groupId) {
            redirectPlayerOneClic(groupId, islive, payway_token, () => {
                this.handleVCard(groupId);
            }, null)
        }
    }

    @autobind
    private handleVCard(groupId: string) {
        if (groupId) {
            const { history } = this.props;
            history.replace(`/vcard/${groupId}`);
        }
    }


    @autobind
    private showTicket(resp: any, groupId: string, islive: boolean) {
        const { currency, price, family, periodicity = '', bonus, frequency = '', producttype } = this.pbi;
        const { response: { end_date: { day = '', month = '', year = '' } = {}, paymentMethodData: { account = '' } = {}, payway_token = '' } = {} } = resp || {};
        const next_pay = `${day} ${Translator.get(month)} ${year}`;
        //* Ejemplo nueva key: Ticket_Transaccion_TextoDescripcion_{producttype}
        const apaKeyContent = `Ticket_Transaccion_TextoDescripcion_${producttype}`;
        const { worflowstart: { selectedPaymentMethod = '' } = {} } = this.state;
        const selectedPaymentMethodOrAmco = this.hasAmcoPayment() ? GETWAY_AMCO : selectedPaymentMethod;
        const labelPaymentMethod = Translator.get(`ticket_subscription_${selectedPaymentMethodOrAmco}_label`);

        let data: any = {}

        switch (this.transactionType) {
            case TransactionDetailType.BUY_MOVIE:
            case TransactionDetailType.BUY_EPISODE:
            case TransactionDetailType.BUY_SEASON:
            case TransactionDetailType.RENT_MOVIE:
                const { worflowstart: { contentInfo: { contentImageMedium, contentTitle } = {} } } = this.state;
                const duration = Translator.get(periodicity)
                data = {
                    pbi: this.pbi,
                    type: this.transactionType,
                    total: null,
                    days: null,
                    content: null,
                    payment_method: account,
                    img_large: contentImageMedium,
                    providerImage: null,
                    contentTitle,
                    transactionType: this.transactionType,
                    labelPaymentMethod,
                    next_pay: frequency == 0 ? null : `${frequency} ${duration}`
                };
                break;
            case TransactionDetailType.SUSCRIPTION:
                // Se deja lo que ya estaba
                const daysPrefix = Translator.get(`transactional_${bonus}_subscription_tryInvite_description`, '')
                const daysContent = Translator.get(`bonus_${producttype}`, '')
                const ticketPrice = getTransactionalPrice({
                    component: TRANSACTION_COMPONENT_TICKET,
                    currency:currency,
                    price:price
                    });
                const ticketBonus = getTransactionalBonus({
                    component: TRANSACTION_COMPONENT_TICKET,
                    bonus,
                    producttype,
                    family
                });

                data = {
                    pbi: this.pbi,
                    type: this.transactionType,
                    total: ticketPrice, //[Ticket] Price Ej. $ 9999 / Mes,
                    bonus: ticketBonus,
                    days: `${daysPrefix} ${daysContent}`,
                    content: `${Translator.get(apaKeyContent, '')}`,
                    payment_method: account,
                    next_pay,
                    img_large: this.getContentImage(),
                    img_largeSub: Assets.get(`${this.region}_transactional_${family}_poster`, ''),
                    providerImage: this.getProviderImage(),
                    labelPaymentMethod,
                    from: this.from,
                    islive: this.props.location.state.islive,
                    groupId: this.props.location.state.groupId
                };
                break;
            default:
                data = {};
        }

        const modal = {
            modalType: AAF_MODAL_SUCCESS_SUSCRIPTION,
            modalProps: {
                data: handleTypeModal({ ...data}),
                handlePlay: () => this.from ? this.handleHomeAddOn(resp) : this.handlePlay(groupId, payway_token, islive),
                handleVCard: () => this.props.location.state.islive ? this.handleHomeAddOn(resp) : this.handleVCard(groupId),
            }
        };

        store.dispatch(showModal(modal));

    }

    private showBonus(bonus: string) {
        if (bonus === '') {
            return false;
        } else {
            return bonus !== Translator.get(bonus)
        }
    }

    private redirectVCard(resp: any): void {
        this.setState({ isLoading: false });
        const { groupId = '', oneoffertype = '', islive = false } = this.pbi;
        const { worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                setTimeout(() => {
                    const { history } = this.props;
                    const nav = Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
                    if (islive) {
                        if(nav && nav.home) {
                            history.replace(`/node/${nav.home}`);
                        }
                    }
                    else if (groupId) {
                        this.handleVCard(groupId);
                    }
                }, 0);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        }
        else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    private getData(): void {

        const { linkworkflowstart, offerid, groupId } = this.pbi;
        const { history } = this.props;

        getwWorkflowstart(linkworkflowstart, groupId, offerid).then((resp) => {
            const ws: IWorkflowstart = parseWorkFlowStart(resp.response);
            this.setState({ worflowstart: ws, isLoading: false }, () =>{
                if(Utils.isModalHide()){
                    setInitialFocus('.initial-focus', false);
                }
            });
        }).catch((err) => {
            if(err === "Workflowstart retry") return;
            const isIPTV = isPTVUSer();
            console.log("@@@@@ ERR CODE:", err)

            if (isIPTV && err.code === 'loggin_required') {
                history.goBack();
            } else {
                this.setState({ isLoading: false }, () => {
                    showError(err, history.goBack());
                });
            }
        });
    }

    private getProviderImage(): string {

        const { family } = this.pbi;

        switch (this.transactionType) {
            case TransactionDetailType.BUY_MOVIE:
            case TransactionDetailType.RENT_MOVIE:
            case TransactionDetailType.BUY_EPISODE:
            case TransactionDetailType.BUY_SEASON:
                return '';
            case TransactionDetailType.SUSCRIPTION:
                const assetName = `transactional_${family}_logo`;
                return Assets.get(assetName, assetName);
            default:
                return '';
        }
    }

    private getContentImage(): string {
        const { banner } = this.pbi;
        let image = '';
        if (this.transactionType === TransactionDetailType.SUSCRIPTION) {
            const imageKey = `${this.region}_transactional_${banner}_poster`;
            image = Assets.get(imageKey, '');
        }

        return image;
    }

    private getTitle(): string {
        switch (this.transactionType) {
            case TransactionDetailType.BUY_MOVIE:
            case TransactionDetailType.BUY_EPISODE:
            case TransactionDetailType.BUY_SEASON:
                return Translator.get('checkout_purchase_title_label', 'Estás por comprar');
            case TransactionDetailType.RENT_MOVIE:
                return Translator.get('checkout_rent_title_label', 'Estás por alquilar');
            case TransactionDetailType.SUSCRIPTION:
                return Translator.get('checkout_subscription_title_label', 'Estás por contratar');
            default:
                return '';
        }
    }

    private getTextButtonAccept() {
        switch (this.transactionType) {
            case TransactionDetailType.BUY_MOVIE:
            case TransactionDetailType.BUY_EPISODE:
            case TransactionDetailType.BUY_SEASON:
                return Translator.get('checkout_access_option_button_purchase', 'COMPRAR');
            case TransactionDetailType.RENT_MOVIE:
                return Translator.get('checkout_access_option_button_rent', 'ALQUILAR');
            case TransactionDetailType.SUSCRIPTION:
                return Translator.get('checkout_access_option_button_suscribtion', 'CONTRATAR');
            default:
                return '';
        }
    }

    private getTextAddPaywayButton(hasSavedPayway: boolean) {
        return hasSavedPayway ? Translator.get(`checkout_access_option_button_selectPayment`, 'CAMBIAR MEDIO DE PAGO') :
            Translator.get(`checkout_access_option_button_addPayment`, 'AGREGAR MEDIO DE PAGO');
    }

    private hasAmcoPayment() {
        //solo tienen un metodo de pago y es amcogate
        const { worflowstart: { list } } = this.state;

        if (list && list.length === 1) {
            const existsAmco = list.find(i => i.gateway === GETWAY_AMCO);
            if (existsAmco) {
                return true
            }
            return false
        }
        return false;
    }

    private gethasAmcoPayment(list: any){
        if(this.hasAmcoPayment()){
            return list && list.length > 1;
        } else {
            return  list && list.length >= 1;
        }
    }


    @autobind
    private getPaymentMethod() {
        const { worflowstart: { selectedPaymentMethod = '' } = {} } = this.state;
        const selectedPaymentMethodOrAmco = this.hasAmcoPayment() ? GETWAY_AMCO : this.newMethod ? this.newMethod: selectedPaymentMethod;
        const labelPaymentMethod = Translator.get(`ticket_subscription_${selectedPaymentMethodOrAmco}_label`);
        const {paymentMethodData : {account = false, cardsData = [{ pan: ''}]} = {}} = this.getWorkflow(selectedPaymentMethodOrAmco) || {};
        if (this.hasAmcoPayment()){
            return `${Translator.get('checkout_payment_description_label', 'Paga con')} ${labelPaymentMethod}`
        } else if (account){
            const labelPayment = selectedPaymentMethod === 'claropagosgate' ? cardsData[0].pan : account;
            return `${Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`)} ${labelPayment}`
        } else{
            return '';
        }
    }

    render(): JSX.Element {
        console.log('MARIANO this.props', this.props);
        const { currency, price, family, periodicity, producttype, backButtonAlign = 'right', bonus = '', extraDisclaimer = false, frequency, oneoffertype} = this.pbi;
        const { isLoading, worflowstart: { hasSavedPayway, list, contentInfo: { contentImageMedium, contentTitle, contentOriginalTitle } = {} } } = this.state;
        const {history:{location:{state:{from = ''}={}}={}}={}} = this.props || {};
        const showSavedPaywayButton = hasSavedPayway || this.hasAmcoPayment();
        const showAddPaywayButton = this.gethasAmcoPayment(list);
        //* Ejemplo nueva key: Checkout_Transaccion_TextoDescripcion_{producttype}
        const information = Translator.get(`Checkout_Transaccion_TextoDescripcion_${producttype}`, '');
        const disclaimer = Translator.get(`${family}_disclaimer_description_label`, 'No incluye Compra y renta u otro servicio  de suscripción. Puedes cancelar......');
        const extra_disclaimer = extraDisclaimer ? extraDisclaimer : Translator.get(`checkout_myContents_description_label`, '');
        const titleSerie = Utils.getTitleSerie();

        const checkoutPrice = getTransactionalPrice({
            component: TRANSACTION_COMPONENT_CHECKOUT,
            price,
            currency
        });
        const checkoutTax = getTransactionalTax({
            component: TRANSACTION_COMPONENT_CHECKOUT,
            producttype,
            periodicity,
            oneoffertype,
            frequency: String(frequency)
        })
        const checkoutBonus = getTransactionalBonus({
            component: TRANSACTION_COMPONENT_CHECKOUT,
            bonus,
            producttype,
            family
        });


        if (isLoading) {
            return <Spinner className="checkout" loadingMessage='' />
        }
        else {
            return (
                <Grid>
                    <HeaderCompound
                        align={backButtonAlign}
                        disabled
                        onClick={this.handleBack}
                        textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                        icon={`${Assets.get('top_head_option_back')}`}
                    />
                    <TransactionDetail
                        transactionDetailType={this.transactionType}
                        textBackButton={Translator.get('top_head_option_button_back', 'Regresar')}
                        imgBackButton={Assets.get('top_head_option_back')}
                        title={this.getTitle()}
                        contentImage={contentImageMedium ? contentImageMedium : this.getContentImage()}
                        contentTitle={contentTitle}
                        contentOriginalTitle={contentOriginalTitle}
                        titleSerie={titleSerie}
                        contentNotes={disclaimer}
                        providerImage={this.getProviderImage()}
                        frequency={frequency}
                        duration={Translator.get(periodicity)}
                        information={information}
                        lblTotal={`${Translator.get('subscription_totalCost_description_label', 'Total:')}`}
                        handleAcceptSavedPayway={this.handleAcceptSavedPayway}
                        handleAddPayway={this.handleAddPayway}
                        handleCancelPayway={this.handleCancelPayway}
                        selectedPaymentMethod={this.getPaymentMethod()}
                        textAcceptSavedPayway={this.getTextButtonAccept()}
                        textCancelButton={Translator.get(`checkout_access_option_button_cancel`, 'CANCELAR')}
                        textAddPayway={this.getTextAddPaywayButton(hasSavedPayway)}
                        showSavedPaywayButton={showSavedPaywayButton}
                        showAddPaywayButton={showAddPaywayButton}
                        textStep={this.from ? Translator.get('top_head_step_2_3_label', 'PASO 2 DE 3') : ''}
                        extraDisclaimer={extra_disclaimer}
                        className={Device.getDevice().getPlatform()}
                        checkoutPrice={checkoutPrice}
                        checkoutTax={checkoutTax}
                        checkoutBonus={checkoutBonus}
                    />
                </Grid>
            )
        }
    }
}

const mapDispatchToProps = {
    setMetricsEvent
}

export default connect(null, mapDispatchToProps)(TransactionDetailContainer)



// WEBPACK FOOTER //
// ./src/payments/Checkout/index.tsx